// @flow
export const c1 = '#234637';
export const c2 = '#FFB100';
